import React from 'react';
import '../Styles/Pricing.css';

const Pricing = () => {
  return (
    <div className="pricing-container">
      <header className="pricing-header">
        <h1>Our Pricing Plans</h1>
        <p>Affordable digital solutions for every business — from startups to enterprises.</p>
      </header>
      <div className="pricing-cards">
        <div className="pricing-card">
          <h2>Starter</h2>
          <p className="price">₹500 – ₹1,000</p>
          <ul>
            <li>Basic Poster or Logo</li>
            <li>1 Revision</li>
            <li>2 Day Delivery</li>
          </ul>
        </div>

        <div className="pricing-card popular">
          <h2>Business Website</h2>
          <p className="price">₹3,000 – ₹5,000</p>
          <ul>
            <li>Static or Dynamic Website</li>
            <li>Contact Form</li>
            <li>Mobile Responsive</li>
            <li>SEO Ready</li>
          </ul>
        </div>

        <div className="pricing-card">
          <h2>E-Commerce / Portal</h2>
          <p className="price">₹10,000 – ₹20,000</p>
          <ul>
            <li>Product Listing</li>
            <li>Admin Panel</li>
            <li>Payment Integration</li>
            <li>3 Months Support</li>
          </ul>
        </div>

        <div className="pricing-card">
          <h2>Full-Stack Custom App</h2>
          <p className="price">₹25,000 – ₹1,00,000</p>
          <ul>
            <li>Custom Web Application</li>
            <li>Backend + Frontend</li>
            <li>Database Integration</li>
            <li>Scalable Architecture</li>
          </ul>
        </div>
      </div>

      <footer className="pricing-footer">
        <p>Need a custom quote? <a href="/contact">Contact us</a> today.</p>
      </footer>
    </div>
  );
};

export default Pricing;
